import { Component } from '@angular/core';

@Component({
  selector: 'app-compat-chat',
  template: ''
})
export class CompatChatComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat-chat.component.ts